import React from "react";

const services = [
  {
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: "Freight Forwarding",
    description:
      "Seamless international freight coordination across air, sea, and land. We manage every detail — documentation, routing, and compliance — so your shipment arrives on schedule.",
    highlight: "Global Network",
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    ),
    title: "Warehousing",
    description:
      "State-of-the-art storage facilities with real-time inventory management, climate control, and advanced security — designed to keep your goods safe and your supply chain moving.",
    highlight: "Secure Storage",
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
      </svg>
    ),
    title: "Transportation",
    description:
      "End-to-end domestic and cross-border transportation with a modern fleet. From FTL and LTL to last-mile delivery, we cover every mile with precision and care.",
    highlight: "Door-to-Door",
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    title: "Customs Clearance",
    description:
      "Navigate complex trade regulations with confidence. Our licensed customs brokers handle all documentation, duties, and compliance to ensure fast, hassle-free clearance.",
    highlight: "100% Compliant",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16 animate-on-scroll">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-widest">What We Offer</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mt-3 mb-5">
            End-to-End <span className="gradient-text">Logistics Services</span>
          </h2>
          <p className="max-w-2xl mx-auto text-slate-500 text-base leading-relaxed">
            From a single parcel to complex multi-modal freight operations — we have the expertise, infrastructure, and network to handle it all.
          </p>
        </div>

        {/* Service cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => (
            <div
              key={service.title}
              className={`card-hover animate-on-scroll stagger-${i + 1} bg-white rounded-2xl p-7 border border-slate-100 group relative overflow-hidden`}
            >
              {/* Hover gradient background */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-800 opacity-0 group-hover:opacity-100 transition-opacity duration-400 rounded-2xl" />

              <div className="relative z-10">
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-blue-50 group-hover:bg-white/20 flex items-center justify-center text-blue-600 group-hover:text-white mb-5 transition-all duration-300">
                  {service.icon}
                </div>

                {/* Highlight badge */}
                <span className="inline-block text-xs font-bold text-blue-600 group-hover:text-blue-200 bg-blue-50 group-hover:bg-white/10 px-2.5 py-1 rounded-full mb-3 transition-all duration-300">
                  {service.highlight}
                </span>

                <h3 className="text-lg font-bold text-slate-900 group-hover:text-white mb-3 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-sm text-slate-500 group-hover:text-blue-100 leading-relaxed transition-colors duration-300">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
